import { TypeaheadActionType } from 'analytics/snowplow/events'

type OnLocationSelect = (
  searchItem?: App.SearchItem,
  mouseEvent?: React.MouseEvent<HTMLElement>,
  actionType?: TypeaheadActionType,
  position?: App.SearchItemPosition,
) => void

export function handleSectionClick(
  searchItem: App.SearchItem | undefined,
  items: Array<App.SearchItem>,
  cols: number | undefined,
  onLocationSelect: OnLocationSelect,
) {
  if (!searchItem) {
    onLocationSelect(searchItem)
    return
  }

  const itemIndex = items.findIndex(item => item.value === searchItem.value)
  if (itemIndex === -1 || cols === undefined) {
    onLocationSelect(searchItem)
    return
  }

  const x = itemIndex % cols
  const y = Math.floor(itemIndex / cols)
  const numRows = Math.ceil(items.length / cols)

  onLocationSelect(searchItem, undefined, undefined, { x, y, numRows, numCols: cols })
}
